import { parseValue } from "../../../../../../ui library/helpers/functions";

import { ActionItemDateAnswer } from "./ActionItemDateAnswer";
import ClientAddressField from "./ClientAddressField";
import { CurrencyAnswer } from "./CurrencyAnswer";
import { DateAnswer } from "./DateAnswer";
import { SelectAnswer } from "./SelectAnswer";
import { StaticSelectAnswer } from "./StaticSelectAnswer";
import { TextAnswer } from "./TextAnswer";
import { TimeAnswer } from "./TimeAnswer";
import { WithSearchSelectAnswer } from "./WithSearchSelectAnswer";

export function FieldModule({
  name,
  prop,
  value,
  onChange,
  enumUrl,
  label,
  placeholder,
  subTitle,
  footer,
  isRequired,
  staticOptions,
  props = {},
  readOnly = {},
  formValues = {},
}) {
  const labelText = `${label || prop?.tile}${isRequired ? " *" : ""}`;

  const handleChange = (field, value) => {
    const parsedValue = parseValue(value, prop?.type);
    onChange(field, parsedValue);
  };

  const commonProps = {
    name,
    label: labelText,
    value,
    onChange: handleChange,
    placeholder,
    subTitle,
    footer,
    error: isRequired && !value,
    ...props,
  };

  if (name === "address") {
    return (
      <ClientAddressField
        label={labelText}
        value={value}
        onChange={(val) => onChange(name, parseValue(val, prop?.type))}
        readOnly={readOnly}
        isRequired={isRequired}
        displayKey={`${name}_display`}
      />
    );
  }

  if (prop?.format === "date-time") {
    return (
      <div className="w-full">
        <ActionItemDateAnswer {...commonProps} propType={prop?.type} />
      </div>
    );
  }

  if (prop?.format === "date") {
    return (
      <div className="w-full">
        <DateAnswer {...commonProps} />
      </div>
    );
  }

  if (prop?.format === "time") {
    return (
      <div className="w-full">
        <TimeAnswer {...commonProps} />
      </div>
    );
  }

  if (Array.isArray(staticOptions) && staticOptions.length > 0) {
    return (
      <div className="w-full">
        <StaticSelectAnswer
          label={labelText}
          name={name}
          onChange={onChange}
          value={value}
          placeholder={placeholder}
          options={staticOptions}
          schema={{ type: prop?.type }}
        />
      </div>
    );
  }

  if (enumUrl && Boolean(prop?.typeProperties?.searchable)) {
    return (
      <div className="w-full">
        <WithSearchSelectAnswer
          {...commonProps}
          typeProperties={prop.typeProperties ?? {}}
          enumUrl={enumUrl}
          formValues={formValues}
        />
      </div>
    );
  }

  if (enumUrl) {
    return (
      <div className="w-full">
        <SelectAnswer {...commonProps} enumUrl={enumUrl} />
      </div>
    );
  }

  if (prop?.type === "string" && prop?.pattern) {
    return (
      <div className="w-full">
        <CurrencyAnswer {...commonProps} pattern={prop.pattern} inputMode="decimal" />
      </div>
    );
  }

  return (
    <div className="w-full">
      <TextAnswer {...commonProps} propType={prop?.type} />
    </div>
  );
}
